import React, { useState, useEffect } from "react";
import {
    Badge,
    Breadcrumbs,
    Button,
    Checkbox,
    Collapse,
    FormControl,
    FormControlLabel,
    Grid, IconButton, InputAdornment, InputLabel, Link, OutlinedInput, Paper, Select, Tab, Tabs, TextField, Typography,
    FormHelperText,
    InputBase
} from "@material-ui/core";
import useStyles from "./styles";
import { SearchOutlined } from "@material-ui/icons";
import Loader from './../../components/Loader/Loader';
import Hotline from './../../assets/img/status/Hotline.svg';
import ActiveIcon from './../../assets/img/status/Active.svg';
import Inactive from './../../assets/img/status/Inactive.svg';
import Rejected from './../../assets/img/status/Rejected.svg';
import Suspended from './../../assets/img/status/Suspended.svg';
import PortInCancel from './../../assets/img/status/Port-In-Cancel.svg';
import Disconnected from './../../assets/img/status/Disconnected.svg';
import FiggLogo from "./../../assets/img/LogoBlue.svg";
import { PostDataAPI } from '../../Services/APIService';
import SearchGridSSP from "./../../components/table/SearchGrid_SSP";

import { GetUserInfo } from "../../Services/GetUserInfo";
import { withSnackbar } from "./../../components/Message/Alert";
import { ActionDialog } from "./../../components/ActionDialog/ActionDialog";
import { SearchOutlined as SearchIcon } from '@material-ui/icons';
import ClearIcon from '@material-ui/icons/Clear';
import LineDetailsDialog from "./components/lineDetails/LineDetails";
import LineForwardNumberDialog from "./components/lineForwardNumber/ForwardNumber";
import AddNewLine from "./components/addLineToAccount/AddNewLine";
import PortANumber from "./components/newRegistrationDialog/NewRegistrationDialog";
import UsageDetailsDialog from "./components/usageDetails/UsageDetails";
import MonthlyUsageSummary from "./components/monthlyUsageSummary/MonthlyUsageSummary";
import ChangePhoneNumberDialog from "./components/changePhoneNumber/ChangePhoneNumber";
import ChangeLineName from "./components/changeLineName/ChangeLineName";
import CustomNotesDialog from './components/customNotes/CustomNotes.js';
import ViewCustomerNotes from './components/viewCustomerNotes/viewCustomerNotes.js';
import ViewActivityLog from './components/viewLog/viewActivityLog';
import SwapSim from "./components/swapsim/SwapSim";
import AddCash from "./components/addCash/AddCash";
import DataBoost from "./components/dataBoost/DataBoost";
import { GetUserRolesRights } from '../../Services/GetUserRolesRights';
import DateFilter from "./components/datefilters/DateFilters"
import ChangeShippingAddress from '../prepaid/components/changeShippingAddress/ChangeShippingAddress';//'./components/changeShippingAddress/ChangeShippingAddress';
import { formatNumberComma, generateRandomNumber, maskAccountNumber, formatDateTime, getFormatedDate } from '../../../src/components/Common/Extensions';
import Tooltip from '@material-ui/core/Tooltip';
import * as signalR from "@microsoft/signalr";
import CircularProgress from '@material-ui/core/CircularProgress';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { Table, Empty, Dropdown, message, Menu } from 'antd';
import { useSignalR } from '../../Services/SignalRContext';
import ReconnectPhoneNumber from "./components/reconnectPhoneNumber/ReconnectPhoneNumber";


function LineManagement({ ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const signalRService = useSignalR();
    const [messages, setMessages] = useState([]);
    let user_info = JSON.parse(GetUserInfo());
    let user_role_rights_list = JSON.parse(GetUserRolesRights());
    const [loginUser, setLoginUser] = useState(user_info.user);
    const [userRole, setUserRole] = useState(user_info.user.roleId);
    const [isPrepaid, setIsPrepaid] = useState(user_info.user.isPrepaid);

    const [signalRConnection, setSignalRConnection] = useState(null)
    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }
    //action dialog 
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })
    const [accountNumber] = useState(user_info.user.accountNumber);
    const [state, setState] = useState({ accounts: "", PIN: '' });
    const [lstWireless, setLstWireless] = useState([]);
    const [customerInformation, setCustomerInformation] = useState();
    const [isLoading, setIsLoading] = useState(false);

    const [showAddLineToExistingAccountDialog, setShowAddLineToExistingAccount] = useState(false);
    const [showPortANumber, setShowPortANumber] = useState(false);
    const [totalActive, setTotalActive] = useState(0);
    const [totalInactive, setTotalInactive] = useState(0);
    const [totalSuspended, setTotalSuspended] = useState(0);
    const [totalDisconnected, setTotalDisconnected] = useState(0);
    const [totalHotlined, setTotalHotlined] = useState(0);
    const [totalRejected, setTotalRejected] = useState(0);
    const [totalPortCancelled, setTotalPortCancelled] = useState(0);
    const [changeShippingAddress, setChangeShippingAddress] = useState(false);
    const [objAddress, setObjAddress] = useState({});

    const AddLineToExistingAccount = () => {
        if (customerInformation?.objCustomerInfo?.isPrepaid && !customerInformation?.objCustomerInfo?.creditCardNumber) {
            saveActivityLogInfo("Line Management", "Add A Line Clicked", "User clicked Add A Line but payment information was missing, so the payment information update dialog was opened", accountNumber);
            showMessage("Alert", "Please provide valid payment information to add a line", "warning", 5000);
            setChangeShippingAddress(true);

        }
        else {
            saveActivityLogInfo("Line Management", "Add A Line Clicked", "User opened the Add A Line dialog", accountNumber);
            setShowAddLineToExistingAccount(true);

        }
    }
    const handleStatusClick = (event, status) => {
        saveActivityLogInfo("Line Management", "Status Filter Selected", `User selected the ${status} status card showing ${formatNumberComma(getStatusCount(status))} lines`, accountNumber);
        setSelectedStatus(status);
        loadWirelessLinesGrid(accountNumber, status);
    }

    const openPortInDialog = () => {
        saveActivityLogInfo("Line Management", "Port In Clicked", "User opened the Port In dialog", accountNumber);
        setShowPortANumber(true);
    }

    const handleSuccessClose = (message) => {
        showMessage("Success", message, "success", 5000);
        setChangePhoneNumberDialogState(false);
        setUserChangeLineName(false);
        setUserSwapSim(false);
        setReconnectPhoneDialogFlag(false);
        setCustomNotesDialog(false);
        setForwardNumberDialogState(false);
        setShowPortANumber(false)
        closeDataBoost();
        closeAddCash();
        loadWirelessLinesStats(accountNumber);
    }
    const handleChangeAddressSuccessClose = (_address) => {
        var existingData = customerInformation.objCustomerInfo;
        existingData.billingAddress1 = _address.address1
        existingData.billingAddress2 = _address.address2
        existingData.billingCity = _address.city;
        existingData.billingState = _address.state;
        existingData.billingZip = _address.zip;
        existingData.billingName = _address.billingName;
        existingData.creditCardNumber = _address.creditCardNumber;
        existingData.creditCardType = _address.creditCardType;
        existingData.creditCardExpiration = _address.creditCardExpiration;
        existingData.creditCardExpirationCvv = _address.creditCardExpirationCvv;

        showMessage("Success", "Payment information updated successfully.", "success", 3000);
        setChangeShippingAddress(false);
        setTimeout(() => {
            setShowAddLineToExistingAccount(true);
        }, 1000);
    }

    const [lineUserName, setLineUserName] = useState('');
    const [oldICC, setOldICC] = useState('');
    const [mdnNumber, setMdnNumber] = useState('');
    const [wirelessId, setWirelessId] = useState('');
    const [lineDetails, setLineDetails] = useState({});
    const [lineDetailsDialogState, setLineDetailsDialogState] = useState(false);
    const [forwardNumberDialogState, setForwardNumberDialogState] = useState(false);
    const [userDetailsDialogState, setUserDetailsDialogState] = useState(false);
    const [changePhoneNumberDialogState, setChangePhoneNumberDialogState] = useState(false);
    const [userSwapSim, setUserSwapSim] = useState(false);
    const [userChangeLineName, setUserChangeLineName] = useState(false);
    const [noteLevel, setNoteLevel] = useState('LineLevel');
    const [customNotesDialog, setCustomNotesDialog] = useState(false);
    const [monthlyUsageSummary, setMonthlyUsageSummary] = useState(false);
    const [dateFilter, setDateFilter] = useState(false);
    const [selectedDateFilters, setSelectedDateFilter] = useState({ fromDate: '', toDate: '' });
    const [viewCustomerNotes, setViewCustomerNotes] = useState(false);
    const [addCash, setAddCash] = useState(false);
    const [dataBoost, setDataBoost] = useState(false);
    const [loadActivityLogType, setLogActivityLogType] = useState('');
    const [viewActivityLog, setViewActivityLog] = useState(false);
    const [iCCNumber, setICCNumber] = useState('');
    const [totalRows, setTotalRows] = useState(0);
    const [selectedStatus, setSelectedStatus] = useState('Active');
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [sortColumn, setSortColumn] = useState('');
    const [sortOrder, setSortOrder] = useState('');
    const [syncButtonText, setSyncButtonText] = useState(sessionStorage.getItem('isLineSyncing') == 'true' ? 'Refresh lines in progress' : 'Refresh Lines Data');
    const [isSyncing, setIsSyncing] = useState(sessionStorage.getItem('isLineSyncing') == 'true' ? true : false);
    const [reconnectPhoneDialogFlag, setReconnectPhoneDialogFlag] = useState(false);
    const generateUsageReport = (_filters) => {
        saveActivityLogInfo("Line Management", "Monthly Usage Report Generated", `User generated monthly usage report for ${getLineSummary(lineDetails)} from ${getFormatedDate(_filters.fromDate.toString(), 'YYYY-MM-DD')} to ${getFormatedDate(_filters.toDate.toString(), 'YYYY-MM-DD')}`, mdnNumber);
        setSelectedDateFilter(prevState => ({
            ...prevState,
            fromDate: _filters.fromDate.toString(),
            toDate: _filters.toDate.toString()

        }))
        setDateFilter(false)
        var params = {
            mdnNumber: mdnNumber,
            accountNumber: accountNumber,
            fromDate: getFormatedDate(_filters.fromDate.toString(), 'YYYY-MM-DD') + '',
            toDate: getFormatedDate(_filters.toDate.toString(), 'YYYY-MM-DD') + '',
            searchFilter: 'LineLevel'
        }

        setIsLoading(true)
        PostDataAPI("telispire/exportMonthlyUsageDetails", params, true).then((result) => {
            setIsLoading(false)
            if (result.success && result.data) {
                window.location.assign("." + result.data);
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }

        })
        //setMonthlyUsageSummary(true)
    }

    const openNoteDialog = (noteLevel) => {
        setNoteLevel(noteLevel);
        setCustomNotesDialog(true)
    }

    const viewActivityClose = () => {
        setViewActivityLog(false)
    }

    const closeAddCash = () => {
        setAddCash(false);
    }
    const showAddCashDialog = () => {
        setAddCash(true);
    }

    const openDataBoost = () => {
        setDataBoost(true)
    }
    const closeDataBoost = () => {
        setDataBoost(false)
    }

    const showActivityLog = (type) => {
        setLogActivityLogType(type);
        setViewActivityLog(true)
    }

    const handleActivateNewLineClose = (_message) => {
        showMessage("Success", _message, "success", 3000);
        setShowAddLineToExistingAccount(false);
        loadWirelessLinesStats(accountNumber);
    }
    const handleNewLineClose = () => {
        setShowAddLineToExistingAccount(false);
    }

    const openActionDialog = (message, action, wirelessId, mdnNumber, lineUsername) => {
        showActionDialog("Are you sure you want to " + message + " this line?", "confirm", function () {
            saveActivityLogInfo("Line Management", `${toTitleCase(message)} Line Confirmed`, `User confirmed ${message} request for line ${buildLineIdentity(mdnNumber, lineUsername)}`, mdnNumber);
            if (action === "disconnect") {
                disconnectLineByMDN(wirelessId, mdnNumber, lineUsername);
            }
            else if (action === "suspendNumber") {
                suspendLineByMDN(wirelessId, mdnNumber, lineUsername);
            }
            else if (action === "restore") {
                restoreLineByMDN(wirelessId, mdnNumber, lineUsername);
            }
        });
    }

    const stopForwardNumber = (wirelessId, mdn, lineName) => {
        var obj = {
            wirelessId: wirelessId,
            MDN: mdn,
            userName: customerInformation?.objCustomerInfo?.fullName,
            lineUserName: lineName,
            emailAddress: customerInformation?.objCustomerInfo?.email,
            accountNumber: accountNumber,
            isPrepaid: isPrepaid,
            loginUserName: loginUser.firstName
        };
        setIsLoading(true)
        PostDataAPI("telispire/stopForwardToPhoneNumber", obj, true).then((result) => {
            setIsLoading(false)
            if (result.success && result.data != null) {
                showMessage("Success", "Stop forwarding request received; process will complete in 30 minutes.", "success", 5000);
                loadWirelessLinesStats(accountNumber);
            } else {
                showMessage("Error", "Unable to stop forwarding to the specified phone number.", "error", 3000);
            }
        })
    }

    const disconnectLineByMDN = (wirelessId, mdn, lineName) => {
        var obj = {
            wirelessId: wirelessId,
            MDN: mdn,
            userName: customerInformation?.objCustomerInfo?.fullName,
            emailAddress: customerInformation?.objCustomerInfo?.email,
            accountNumber: accountNumber,
            isPrepaid: isPrepaid,
            loginUserName: loginUser.firstName,
            lineUserName: lineName,
        };
        setIsLoading(true)
        PostDataAPI("telispire/disconnectLineByMDN", obj, true).then((result) => {
            setIsLoading(false)
            if (result.success && result.data != null) {
                showMessage("Success", "Line successfully disconnected.", "success", 3000);
                loadWirelessLinesStats(accountNumber);
            } else {
                showMessage("Error", result.message, "error", 3000);
            }
        })
    }

    //Line cannot be used (not disconnected, and can be restored
    const suspendLineByMDN = (wirelessId, mdn, lineName) => {
        var obj = {
            wirelessId: wirelessId,
            MDN: mdn,
            userName: customerInformation?.objCustomerInfo?.fullName,
            emailAddress: customerInformation?.objCustomerInfo?.email,
            accountNumber: accountNumber,
            isPrepaid: isPrepaid,
            loginUserName: loginUser.firstName,
            lineUserName: lineName,
        };
        setIsLoading(true)
        PostDataAPI("telispire/suspendLineByMDN", obj, true).then((result) => {
            setIsLoading(false)
            if (result.success && result.data != null) {
                showMessage("Success", "Line suspended successfully.", "success", 3000);
                loadWirelessLinesStats(accountNumber);
            } else {
                showMessage("Error", result.message, "error", 3000);
            }
        })
    }

    //function to restore the line
    const restoreLineByMDN = (wirelessId, mdn, lineName) => {
        var obj = {
            wirelessId: wirelessId,
            MDN: mdn,
            userName: customerInformation?.objCustomerInfo?.fullName,
            emailAddress: customerInformation?.objCustomerInfo?.email,
            accountNumber: accountNumber,
            isPrepaid: isPrepaid,
            loginUserName: loginUser.firstName,
            lineUserName: lineName,
        };
        setIsLoading(true)
        PostDataAPI("telispire/restoreLineByMDN", obj, true).then((result) => {
            setIsLoading(false)
            if (result.success && result.data != null) {
                showMessage("Success", "Line restored successfully.", "success", 3000);
                loadWirelessLinesStats(accountNumber);
            } else {
                showMessage("Error", result.message, "error", 3000);
            }
        })
    }

    const handleActionClick = (key, item) => {
        setLineUserName(item.username)
        setOldICC(item.iCC);
        setMdnNumber(item.mDN);
        setWirelessId(item.id);
        setLineDetails(item);
        setICCNumber(item.iCC);
        logLineRowAction(key, item);
        if (key === "lineDetails") {
            setLineDetailsDialogState(true);
        } else if (key === "usage") {
            setUserDetailsDialogState(true);
        } else if (key === "changePhoneNumber") {
            setChangePhoneNumberDialogState(true);
        } else if (key === "simSwipe") {
            setUserSwapSim(true);
        } else if (key === "forwardNumber") {
            setForwardNumberDialogState(true);
        }
        else if (key === "stopForwardNumber") {
            showActionDialog("Are you sure you want to stop forwarding this line?", "confirm", function () {
                saveActivityLogInfo("Line Management", "Stop Forwarding Confirmed", `User confirmed stop forwarding request for ${getLineSummary(item)}. Forwarded to: ${item.forwardToNumber || "not available"}`, item.mDN);
                stopForwardNumber(item.id, item.mDN, item.username)
            });
        }
        else if (key === "changeLineName") {
            setUserChangeLineName(true)
        } else if (key === "customerNotes") {
            openNoteDialog('LineLevel');
        } else if (key === "imeiCheck") {
            if (item.eSN) {
                var imeiURL = "https://swappa.com/imei/info/" + item.eSN;
                window.open(imeiURL, "_blank");
            }
            else
                showMessage("Error", "IMEI number is missing.", "error", 3000);
        } else if (key === "monthlyUsage") {
            setDateFilter(true)
            //setMonthlyUsageSummary(true);
        } else if (key === "disconnect") {
            openActionDialog("disconnect", key, item.id, item.mDN, item.username);
        } else if (key === "reconnect") {
            //openActionDialog("reconnect", key, item.id, item.mDN, item.username);
            setReconnectPhoneDialogFlag(true);
        } else if (key === "suspendNumber") {
            openActionDialog("suspend", key, item.id, item.mDN, item.username);
        } else if (key === "restore") {
            openActionDialog("restore", key, item.id, item.mDN, item.username);
        } else if (key === "viewCustomerNotes") {
            setViewCustomerNotes(true)
        } else if (key === "viewActivityLog") {
            showActivityLog('Line');
        } else if (key === "bucketUpdate") {
            openDataBoost();
        } else if (key === "addCash") {
            showAddCashDialog();
        }
    }

    const handleWirelessGridUpdate = () => {
        setIsDataGridUpdate(generateRandomNumber());
    }
    const loadWirelessLinesStats = (accountNo) => {

        setIsLoading(true);
        var obj = { accountNumber: accountNo };
        PostDataAPI("telispire/loadWirelessLinesStats", obj).then((result) => {
            setIsLoading(false);
            if (result.success && result.data) {
                setCustomerInformation((prevState) => ({
                    ...prevState,
                    objCustomerInfo: result.data.objCustomerInfo,

                }));
                setObjAddress({
                    address1: result.data.objCustomerInfo.billingAddress1,
                    address2: result.data.objCustomerInfo.billingAddress2,
                    city: result.data.objCustomerInfo.billingCity,
                    state: result.data.objCustomerInfo.billingState,
                    zip: result.data.objCustomerInfo.billingZip,
                    billingName: result.data.objCustomerInfo.billingName,
                    creditCardNumber: result.data.objCustomerInfo.creditCardNumber,
                    creditCardType: result.data.objCustomerInfo.creditCardType,
                    creditCardExpiration: result.data.objCustomerInfo.creditCardExpiration,
                    creditCardExpirationCvv: result.data.objCustomerInfo.creditCardExpirationCvv,
                });
                setTotalActive(result.data.active);
                setTotalInactive(result.data.inactive);
                setTotalSuspended(result.data.suspended);
                setTotalDisconnected(result.data.disconnected);
                setTotalHotlined(result.data.hotlined);
                setTotalRejected(result.data.rejected);
                setTotalPortCancelled(result.data.portCancelled);

                loadWirelessLinesGrid(accountNo, selectedStatus);

            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }

        });
    }
    const loadWirelessLinesGrid = (accountNo, status, page, pageSize, isClearSearch, sortColumn, sortOrder) => {
        setIsLoading(true);
        setLstWireless([]);
        handleWirelessGridUpdate();
        var param = {
            extraParams: [accountNo, !isPrepaid ? status : status, isClearSearch ? '' : searchFilter],
            pageSize: pageSize, pageNumber: page, sortColumn: sortColumn ? sortColumn : '', sortOrder: sortOrder ? sortOrder : ''
        };
        PostDataAPI("telispire/loadWirelessLinesGrid", param).then((result) => {
            setIsLoading(false);
            if (result.success && result.data) {
                //if (accountNo === "17247285" || accountNo === "16979108") {
                //    result.data = result.data.map(obj => {
                //        if (obj.packageName && obj.packageName.trim() !== "") {
                //            return { ...obj, packageName: "Figgers Text Only" };
                //        }
                //        return obj;
                //    });
                //}
                setLstWireless(result.data);
                setTotalRows(result.dataCount);
                handleWirelessGridUpdate();
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }

        });
    }

    const handleGridChange = (page, pageSize, isClearSearch, sortColumn, sortOrder) => {
        const sortDetails = sortColumn ? ` Sort: ${sortColumn} ${sortOrder || ""}.` : "";
        saveActivityLogInfo("Line Management", "Line Grid Page Changed", `User changed line grid to page ${page} with ${pageSize} rows per page.${sortDetails}`, accountNumber);
        setCurrentPage(page);
        setPageSize(pageSize);
        setSortColumn(sortColumn);
        setSortOrder(sortOrder);
        loadWirelessLinesGrid(accountNumber, selectedStatus, page, pageSize, isClearSearch, sortColumn, sortOrder);
    }

    const [isDataGridUpdate, setIsDataGridUpdate] = useState(false);

    const [searchFilter, setValue] = useState('');

    const handleInputChange = (event) => {
        setValue(event.target.value);
    };
    const handleWirelessGridSearchKeyPress = (e) => {
        const currValue = searchFilter;

        if (e.charCode == 13 && currValue && currValue.trim().length > 0) {
            saveActivityLogInfo("Line Management", "Line Search Submitted", `User searched wireless lines with text "${currValue.trim()}"`, accountNumber);
            //setValue(currValue);
            //handleDataGridUpdate();
            loadWirelessLinesGrid(accountNumber, selectedStatus);
        }
    }
    const handleWirelessGridClearInput = (name) => {
        saveActivityLogInfo("Line Management", "Line Search Cleared", `User cleared wireless line search text "${searchFilter}"`, accountNumber);
        setValue('');
        loadWirelessLinesGrid(accountNumber, selectedStatus, currentPage, pageSize, true, sortColumn, sortOrder);
    };
    const signalRCallbacksyncWirelessLines = () => {
        let baseUrl = sessionStorage.getItem('server_api_url');
        const connection = new signalR.HubConnectionBuilder()
            .withUrl(baseUrl.replace("/api", "") + "fciHub")
            .withAutomaticReconnect([0, 2000, 10000, 30000])  // Customize the reconnection intervals
            .build();
        connection.on("SyncingWirelessLines", (message) => {
            if (message.includes(sessionStorage.getItem('signalRConnectionId'))) {
                const messageParts = message.split('_');
                if (message.includes("syncingstarted")) {
                    showMessage("Success", "Line refresh initiated.", "success", 3000);
                    setSyncButtonText('Refresh lines in progress');
                    setIsSyncing(true);
                }
                else if (message.includes('syncingfinish')) {

                    showMessage("Success", "Refresh completed, lines reloaded.", "success", 3000);
                    if (!accountNumber || messageParts[1] == accountNumber) {
                        //Sycning wireless lines completed reload this lines from local db
                        loadWirelessLinesStats(messageParts[1], selectedStatus);
                        setSyncButtonText('Refresh Lines Data');
                        setIsSyncing(false);
                    }

                }
                else if (message.includes('syncingfailed')) {
                    showMessage("Error", "Refresh failed, please try again later.", "error", 3000);
                    if (!accountNumber || messageParts[1] == accountNumber) {
                        loadWirelessLinesStats(messageParts[1], selectedStatus);
                        setSyncButtonText('Refresh Lines Data');
                        setIsSyncing(false);
                    }

                }
            }

        });

        connection.start()
            .then(() => {
                const signalRConnectionId = sessionStorage.getItem('signalRConnectionId');

                console.log('Connection ID:', signalRConnectionId);
            })
            .catch(err => {
                console.error('Error starting SignalR connection:', err);
            });

        // Handle reconnecting events
        connection.onreconnecting(error => {
            //console.warn(`Connection lost due to ${error}. Reconnecting...`);
            //setSyncButtonText('Reconnecting...');
        });

        // Handle reconnected events
        connection.onreconnected(connectionId => {
            console.log(`Reconnected successfully with connectionId: ${connectionId}`);
            //showMessage("Success", "Reconnected to server.", "success", 3000);
            setSyncButtonText('Refresh Lines Data');
        });

        // Handle disconnection events
        connection.onclose(error => {
            console.error('SignalR connection closed due to error:', error);
            //showMessage("Error", "Connection lost, please refresh the page.", "error", 3000);
            //setSyncButtonText('Reconnect');
        });

        return () => {
            connection.stop();
        };
    }

    const ExportWirelessLines = (exportType) => {
        if (!lstWireless || lstWireless.length <= 0) {
            saveActivityLogInfo("Line Management", "Line Export Attempted", `User attempted to ${exportType == 'Export' ? 'export displayed' : 'export all'} ${selectedStatus} wireless lines, but no records were available`, accountNumber);
            showMessage("Error", "No records available for export.", "error", 3000);
            return;
        }
        saveActivityLogInfo("Line Management", exportType == 'Export' ? "Displayed Lines Exported" : "All Lines Exported", buildExportDetails(exportType), accountNumber);
        var obj = {
            lineIds: exportType == 'Export' ? lstWireless.map(line => line.id).join(',') : '',
            reportName: 'WirelessLines',
            accountNumber: accountNumber,
            exportType: exportType,
            selectedFilter: selectedStatus
        };
        setIsLoading(true);
        PostDataAPI("telispire/exportWirelessLines", obj, true).then((result) => {
            setIsLoading(false)
            if (result.success && result.data != null) {
                window.location.assign("." + result.data);

            } else {
                showMessage("Error", result.message, "error", 3000);
            }
        })
    }
    const SyncWirelessLines = () => {
        if (!isSyncing) {
            saveActivityLogInfo("Line Management", "Line Refresh Started", `User clicked Refresh Lines Data to sync wireless lines. Last sync date: ${formatDateTime(customerInformation?.objCustomerInfo.lastSyncDate) || "not available"}`, accountNumber);
            setSyncButtonText('Refresh lines in progress');
            setIsSyncing(true);
            sessionStorage.setItem('isLineSyncing', 'true');
            var obj = {
                accountNumber: accountNumber,
                signalRConnectionId: sessionStorage.getItem('signalRConnectionId')
            };
            PostDataAPI("telispire/syncWirelessLines", obj, true).then((result) => {
            });
        }
        else {
            saveActivityLogInfo("Line Management", "Line Refresh Clicked", "User clicked Refresh Lines Data while a line refresh was already in progress", accountNumber);
        }

    }
    const handleMessage = (message) => {
        if (message != null && typeof message === 'string' && message.includes(sessionStorage.getItem('signalRConnectionId'))) {
            const messageParts = message.split('_');
            if (message.includes("syncingstarted")) {
                //showMessage("Success", "Line refresh initiated.", "success", 3000);
            }
            else if (message.includes('syncingfinish')) {

                //showMessage("Success", "Refresh completed, lines reloaded.", "success", 3000);
                if (!accountNumber || messageParts[1] == accountNumber) {
                    loadWirelessLinesStats(messageParts[1], selectedStatus);
                    setSyncButtonText('Refresh Lines Data');
                    setIsSyncing(false);
                    sessionStorage.setItem('isLineSyncing', 'false');
                }

            }
            else if (message.includes('syncingfailed')) {
                //showMessage("Error", "Refresh failed, please try again later.", "error", 3000);
                if (!accountNumber || messageParts[1] == accountNumber) {
                    loadWirelessLinesStats(messageParts[1], selectedStatus);
                    setSyncButtonText('Refresh Lines Data');
                    setIsSyncing(false);
                    sessionStorage.setItem('isLineSyncing', 'false');
                }

            }
        }
    };
    const handleReloadLines = () => {
        saveActivityLogInfo("Line Management", "Line Management Reloaded", `User clicked Reload to refresh line counts and the ${selectedStatus} line grid`, accountNumber);
        loadWirelessLinesStats(accountNumber);
    }

    const handleLastSyncDateClick = () => {
        saveActivityLogInfo("Line Management", "Last Sync Date Viewed", `User clicked Last Sync Date. Last sync date: ${formatDateTime(customerInformation?.objCustomerInfo.lastSyncDate) || "not available"}`, accountNumber);
    }

    const handleLineActionMenuOpen = (item) => {
        saveActivityLogInfo("Line Management", "Line Actions Menu Opened", `User opened the Actions menu for ${getLineSummary(item)}`, item?.mDN);
    }

    function saveActivityLogInfo(area, activity, details, entityId) {

        let userInfo = JSON.parse(GetUserInfo()).user;
        let customerId = parseInt((userInfo.customerID || userInfo.customerId || userInfo.userId) + "");
        if (!entityId)
            entityId = accountNumber;
        var params = {
            sessionId: userInfo.currentSessionId,
            entityId: entityId,//parseInt(userInfo.loggedInUserID + ""),
            customer: accountNumber,
            customerId: customerId,
            customerid: customerId,
            area: area,
            activity: activity,
            details: appendLineManagementContext(details),
            activityStatus: "Success",
            platForm: userInfo.platForm || "Corporate Portal"
        };

        PostDataAPI('customer/addActivityLog', params, true).then((result) => {
        })
    }
    function appendLineManagementContext(details) {
        let context = details || "";
        if (accountNumber)
            context += `${context ? ". " : ""}Account: ${maskAccountNumber(accountNumber)}`;
        if (selectedStatus)
            context += `. Selected status filter: ${selectedStatus}`;
        return context;
    }
    function getStatusCount(status) {
        if (status === 'Active')
            return totalActive;
        else if (status === 'Inactive')
            return totalInactive;
        else if (status === 'Suspended')
            return totalSuspended;
        else if (status === 'Disconnected')
            return totalDisconnected;
        else if (status === 'Hotlined')
            return totalHotlined;
        else if (status === 'Rejected')
            return totalRejected;
        else if (status === 'PortCancelled')
            return totalPortCancelled;

        return 0;
    }
    function getLineSummary(item) {
        if (!item)
            return "selected line";

        const lineParts = [
            item.mDN ? `Phone #: ${item.mDN}` : "",
            item.iCC ? `ICC/SIM: ${item.iCC}` : "",
            item.username ? `Name: ${item.username}` : "",
            item.status ? `Status: ${item.status}` : "",
            item.planDisplayName ? `Plan: ${item.planDisplayName}` : item.packageName ? `Plan: ${item.packageName}` : "",
            item.eSN ? `Device: ${item.eSN}` : ""
        ].filter(Boolean);

        return lineParts.length > 0 ? lineParts.join(", ") : "selected line";
    }
    function buildLineIdentity(mdn, lineUsername) {
        return [mdn ? `Phone #: ${mdn}` : "", lineUsername ? `Name: ${lineUsername}` : ""].filter(Boolean).join(", ") || "selected line";
    }
    function getLineActionLogInfo(key) {
        const actionMap = {
            lineDetails: { activity: "Line Details Clicked", detail: "User clicked Line Details" },
            usage: { activity: "Line Usage Clicked", detail: "User clicked Usage" },
            monthlyUsage: { activity: "Monthly Usage Clicked", detail: "User clicked Monthly Usage" },
            changePhoneNumber: { activity: "Change Phone Number Clicked", detail: "User clicked Change Phone Number" },
            changeLineName: { activity: "Change Line Info Clicked", detail: "User clicked Change Line Info" },
            forwardNumber: { activity: "Forward Number Clicked", detail: "User clicked Forward Number" },
            stopForwardNumber: { activity: "Stop Forward Number Clicked", detail: "User clicked Stop Forward Number" },
            suspendNumber: { activity: "Suspend Number Clicked", detail: "User clicked Suspend Number" },
            restore: { activity: "Restore Line Clicked", detail: "User clicked Restore" },
            reconnect: { activity: "Reconnect Line Clicked", detail: "User clicked Reconnect" },
            disconnect: { activity: "Disconnect Line Clicked", detail: "User clicked Disconnect" },
            viewActivityLog: { activity: "Line Activity Log Clicked", detail: "User clicked View Log" },
            simSwipe: { activity: "SIM Swap Clicked", detail: "User clicked SIM Swap" },
            imeiCheck: { activity: "IMEI Check Clicked", detail: "User clicked IMEI Check" },
            customerNotes: { activity: "Add Line Note Clicked", detail: "User clicked Add Notes" },
            viewCustomerNotes: { activity: "View Line Notes Clicked", detail: "User clicked View Notes" },
            bucketUpdate: { activity: "Data Boost Clicked", detail: "User clicked Data Boost" },
            addCash: { activity: "Add Cash Clicked", detail: "User clicked Add Cash" }
        };

        return actionMap[key] || { activity: "Line Action Clicked", detail: `User clicked ${key} action` };
    }
    function logLineRowAction(key, item) {
        const actionInfo = getLineActionLogInfo(key);
        let details = `${actionInfo.detail} from the row Actions menu for ${getLineSummary(item)}`;

        if (key === "imeiCheck" && !item?.eSN)
            details += ". IMEI/device value was missing";
        else if (key === "imeiCheck" && item?.eSN)
            details += `. External IMEI lookup opened for device ${item.eSN}`;
        else if (key === "stopForwardNumber")
            details += `. Current forward number: ${item?.forwardToNumber || "not available"}`;

        saveActivityLogInfo("Line Management", actionInfo.activity, details, item?.mDN || item?.id);
    }
    function buildExportDetails(exportType) {
        const mdns = lstWireless.map(line => line.mDN).filter(Boolean);
        const displayedMdns = mdns.slice(0, 10).join(", ");
        const remainingText = mdns.length > 10 ? `, ${mdns.length - 10} more not shown` : "";
        const scopeText = exportType == 'Export' ? "displayed lines" : "all lines";
        return `User requested ${scopeText} export for ${selectedStatus} wireless lines. Displayed row count: ${lstWireless.length}${displayedMdns ? `. Displayed MDNs: ${displayedMdns}${remainingText}` : ""}`;
    }
    function toTitleCase(value) {
        if (!value)
            return "";

        return value.charAt(0).toUpperCase() + value.slice(1);
    }
    useEffect(() => {
        if (accountNumber) {
            loadWirelessLinesStats(accountNumber);
            saveActivityLogInfo("Line Management", "Line Management Viewed", "User opened line management screen", accountNumber);
        }
        signalRService.subscribeToMessages(handleMessage);

        return () => {
            signalRService.unsubscribeFromMessages(handleMessage);
        };
        //signalRCallbacksyncWirelessLines();
    }, [signalRService])

    return (
        <>
            {isLoading ? <Loader></Loader> : ''}
            <div className={classes.appBarSpacer} />
            <div className={classes.header}>
                <Typography component="h2">Line Management - {maskAccountNumber(accountNumber)}</Typography>

                <div className={classes.floatRight}>
                    {user_role_rights_list.some(item => item.rightName === 'portANumber' && item.permissionCode > 0) ? <Button className={classes.changeBtn} onClick={openPortInDialog}>Port In</Button> : ''}
                    {user_role_rights_list.some(item => item.rightName === 'addNewLine' && item.permissionCode > 0) ? <Button className={classes.changeBtn} onClick={AddLineToExistingAccount}>Add A Line</Button> : ''}
                </div>

            </div>
            <Grid container >
                <div className={classes.accountPaper} >
                    <Grid container row>
                        <div className={classes.statusBoxContainer}>
                            <FormControlLabel
                                className={classes.checkBoxFormLabel}
                                control={
                                    <Checkbox
                                        name="checkedB"
                                        color="primary"
                                        className={classes.checkBoxBtn}
                                        checked={'Active' == selectedStatus}
                                        onClick={(e) => { handleStatusClick(e, 'Active') }}
                                    />
                                }
                                label={<>
                                    <div className={"statusBoxes Active"} >
                                        <div className={classes.statusBoxContent}>
                                            <h5>{'Active'}</h5>
                                            <h2>{formatNumberComma(totalActive)}</h2>
                                        </div>
                                        <img src={ActiveIcon} alt='Active' />
                                    </div>
                                </>}
                            />
                            {/* <FormControlLabel
                                className={classes.checkBoxFormLabel}
                                control={
                                    <Checkbox
                                        name="checkedB"
                                        color="primary"
                                        className={classes.checkBoxBtn}
                                        checked={'Inactive' == selectedStatus}
                                        onClick={(e) => { handleStatusClick(e, 'Inactive') }}
                                    />
                                }
                                label={<>
                                    <div className={"statusBoxes Inactive"}>
                                        <div className={classes.statusBoxContent}>
                                            <h5>{'Inactive'}</h5>
                                            <h2>{formatNumberComma(totalInactive)}</h2>
                                        </div>
                                        <img src={Inactive} alt='Inactive' />
                                    </div>
                                </>}
                            /> */}
                            <FormControlLabel
                                className={classes.checkBoxFormLabel}
                                control={
                                    <Checkbox
                                        name="checkedB"
                                        color="primary"
                                        className={classes.checkBoxBtn}
                                        checked={'Suspended' == selectedStatus}
                                        onClick={(e) => { handleStatusClick(e, 'Suspended') }}
                                    />
                                }
                                label={<>
                                    <div className={"statusBoxes Suspended"}>
                                        <div className={classes.statusBoxContent}>
                                            <h5>{'Suspended'}</h5>
                                            <h2>{formatNumberComma(totalSuspended)}</h2>
                                        </div>
                                        <img src={Suspended} alt='Suspended' />
                                    </div>
                                </>}
                            />
                            <FormControlLabel
                                className={classes.checkBoxFormLabel}
                                control={
                                    <Checkbox
                                        name="checkedB"
                                        color="primary"
                                        className={classes.checkBoxBtn}
                                        checked={'Disconnected' == selectedStatus}
                                        onClick={(e) => { handleStatusClick(e, 'Disconnected') }}
                                    />
                                }
                                label={<>
                                    <div className={"statusBoxes Disconnected"} >
                                        <div className={classes.statusBoxContent}>
                                            <h5>{'Disconnected'}</h5>
                                            <h2>{formatNumberComma(totalDisconnected)}</h2>
                                        </div>
                                        <img src={Disconnected} alt='Disconnected' />
                                    </div>
                                </>}
                            />
                            <FormControlLabel
                                className={classes.checkBoxFormLabel}
                                control={
                                    <Checkbox
                                        name="checkedB"
                                        color="primary"
                                        className={classes.checkBoxBtn}
                                        checked={'Hotlined' == selectedStatus}
                                        onClick={(e) => { handleStatusClick(e, 'Hotlined') }}
                                    />
                                }
                                label={<>
                                    <div className={"statusBoxes Hotline"} >
                                        <div className={classes.statusBoxContent}>
                                            <h5>{'Hotlined'}</h5>
                                            <h2>{formatNumberComma(totalHotlined)}</h2>
                                        </div>
                                        <img src={Hotline} alt='Hotlined' />
                                    </div>
                                </>}
                            />
                            <FormControlLabel
                                className={classes.checkBoxFormLabel}
                                control={
                                    <Checkbox
                                        name="checkedB"
                                        color="primary"
                                        className={classes.checkBoxBtn}
                                        checked={'Rejected' == selectedStatus}
                                        onClick={(e) => { handleStatusClick(e, 'Rejected') }}
                                    />
                                }
                                label={<>
                                    <div className={"statusBoxes Rejected"} >
                                        <div className={classes.statusBoxContent}>
                                            <h5>{'Rejected'}</h5>
                                            <h2>{formatNumberComma(totalRejected)}</h2>
                                        </div>
                                        <img src={Rejected} alt='Rejected' />
                                    </div>
                                </>}
                            />
                            <FormControlLabel
                                className={classes.checkBoxFormLabel}
                                control={
                                    <Checkbox
                                        name="checkedB"
                                        color="primary"
                                        className={classes.checkBoxBtn}
                                        checked={'PortCancelled' == selectedStatus}
                                        onClick={(e) => { handleStatusClick(e, 'PortCancelled') }}
                                    />
                                }
                                label={<>
                                    <div className={"statusBoxes Port-In-Cancel"} >
                                        <div className={classes.statusBoxContent}>
                                            <h5>{'PortCancelled'}</h5>
                                            <h2>{formatNumberComma(totalPortCancelled)}</h2>
                                        </div>
                                        <img src={PortInCancel} alt='PortCancelled' />
                                    </div>
                                </>}
                            />
                        </div>
                    </Grid>
                    <Grid container row className={classes.btnGrid} justifyContent={'right'}>
                        <Dropdown overlay={<Menu>
                            <Menu.Item
                                className={classes.DropdownItems} onClick={() => ExportWirelessLines('Export')}> Export
                            </Menu.Item>

                            <Menu.Item
                                className={classes.DropdownItems} onClick={() => ExportWirelessLines('ExportAll')}>  Export All
                            </Menu.Item>

                        </Menu>
                        } trigger={["click"]}
                            className={classes.actionDropDownnoRound}>
                            <Button className={classes.actionBtn}>
                                Export <ArrowDropDownIcon />
                            </Button>
                        </Dropdown>
                        <Button className={classes.changeBtn} style={{ cursor: 'default' }} onClick={handleLastSyncDateClick}>Last Sync Date: {formatDateTime(customerInformation?.objCustomerInfo.lastSyncDate)}</Button>
                        <Button className={classes.changeBtn} onClick={() => { SyncWirelessLines() }}>{isSyncing ? <CircularProgress size={18} className={classes.circularProgressBar} color="secondary" /> : ''} {syncButtonText}</Button>
                        <Button className={classes.changeBtn} onClick={handleReloadLines}>Reload</Button>

                        <Tooltip title="Search & Press 'Enter'" placement="top">
                            <InputBase
                                className="grid-search-input"
                                value={searchFilter}
                                placeholder="Type & Enter"
                                startAdornment={<SearchIcon />}
                                onChange={handleInputChange}
                                onKeyPress={handleWirelessGridSearchKeyPress}
                                endAdornment={searchFilter ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleWirelessGridClearInput('search') }} /> : ''}
                                inputProps={{ maxLength: 50 }}
                            />
                        </Tooltip>
                    </Grid>
                    <Grid row className={classes.gridHeader}>
                        <div className={classes.gridActions} style={{ marginRight: '7px' }} >
                            {/*<InputBase*/}
                            {/*    value={searchFilter}*/}
                            {/*    placeholder="Search"*/}
                            {/*    className="grid-search-input"*/}
                            {/*    endAdornment={searchFilter ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('search') }} /> : ''}*/}
                            {/*    startAdornment={<SearchIcon />}*/}
                            {/*    onChange={handleSearch}*/}
                            {/*    maxLength="2"*/}
                            {/*/>*/}
                        </div>

                    </Grid>

                    <div className={classes.tabContainer}>

                        <SearchGridSSP
                            columns={selectedStatus == 'Inactive' ? 'PostpaidWirelessInactive' : 'PostpaidWireless'}
                            onActionClick={handleActionClick}
                            list={lstWireless}
                            noRecordMsg={isPrepaid ? "No prepaid line exists" : "No postpaid line exists"}
                            isTopPagination={true}
                            Icon={true}
                            isUpdate={isDataGridUpdate}
                            totalRows={totalRows}
                            handlePageChange={handleGridChange}
                            onActionMenuOpen={handleLineActionMenuOpen}

                        />
                    </div>
                </div>
            </Grid>
            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />

            {
                lineDetailsDialogState ? <LineDetailsDialog
                    dialogOpenClose={lineDetailsDialogState}
                    handleClose={() => setLineDetailsDialogState(false)}
                    mdnNumber={mdnNumber}
                    wirelessId={wirelessId}
                    accountNumber={accountNumber}
                    isPrepaid={isPrepaid}
                    lineDetails={lineDetails}
                    iCCNumber={iCCNumber}
                /> : null
            }
            {
                userDetailsDialogState ? <UsageDetailsDialog
                    dialogOpenClose={userDetailsDialogState}
                    handleClose={() => setUserDetailsDialogState(false)}
                    mdnNumber={mdnNumber}
                    accountNumber={accountNumber}
                    lineUserName={lineUserName}
                    userName={customerInformation?.objCustomerInfo?.fullName}
                    emailAddress={customerInformation?.objCustomerInfo?.email}
                    billingCycle={customerInformation?.objCustomerInfo?.billingCycle}
                /> : null
            }
            {
                monthlyUsageSummary ?
                    <MonthlyUsageSummary
                        dialogOpenClose={monthlyUsageSummary}
                        handleClose={() => setMonthlyUsageSummary(false)}
                        mdnNumber={mdnNumber}
                        accountNumber={accountNumber}
                        dateFilters={selectedDateFilters}
                        searchFilter={'LineLevel'}
                    ></MonthlyUsageSummary> : null
            }
            {
                dateFilter ?
                    <DateFilter
                        generateReport={generateUsageReport}
                        dialogOpenClose={dateFilter}
                        handleClose={() => setDateFilter(false)}>
                    </DateFilter> : null
            }
            {
                changePhoneNumberDialogState ? <ChangePhoneNumberDialog
                    dialogOpenClose={changePhoneNumberDialogState}
                    handleClose={() => setChangePhoneNumberDialogState(false)}
                    handleSuccessClose={handleSuccessClose}
                    mdnNumber={mdnNumber}
                    accountNumber={accountNumber}
                    userName={customerInformation?.objCustomerInfo?.fullName}
                    emailAddress={customerInformation?.objCustomerInfo?.email}
                    lineUserName={lineUserName}
                    loginUserName={loginUser.firstName}
                    icc={oldICC}
                /> : null
            }
            {
                userChangeLineName ? <ChangeLineName
                    dialogOpenClose={userChangeLineName}
                    handleClose={() => setUserChangeLineName(false)}
                    handleSuccessClose={handleSuccessClose}
                    mdnNumber={mdnNumber}
                    loginUserName={loginUser.firstName}
                    accountNumber={accountNumber}
                    userName={customerInformation?.objCustomerInfo?.fullName}
                    lineDetails={lineDetails}
                    emailAddress={customerInformation?.objCustomerInfo?.email}
                /> : null
            }
            {
                customNotesDialog ?
                    <CustomNotesDialog
                        dialogOpenClose={customNotesDialog}
                        handleClose={() => setCustomNotesDialog(false)}
                        handleSuccessClose={handleSuccessClose}
                        mdnNumber={mdnNumber}
                        wirelessId={wirelessId}
                        accountNumber={accountNumber}
                        userName={customerInformation?.objCustomerInfo?.fullName}
                        emailAddress={customerInformation?.objCustomerInfo?.email}
                        noteType={noteLevel}
                    ></CustomNotesDialog> : null
            }
            {
                viewCustomerNotes ?
                    <ViewCustomerNotes
                        dialogOpenClose={viewCustomerNotes}
                        handleClose={() => setViewCustomerNotes(false)}
                        handleSuccessClose={handleSuccessClose}
                        mdnNumber={mdnNumber}
                        wirelessId={wirelessId}
                        accountNumber={accountNumber}
                        userName={customerInformation?.objCustomerInfo?.fullName}
                        emailAddress={customerInformation?.objCustomerInfo?.email}
                        noteType='LineLevel'
                    >
                    </ViewCustomerNotes> : null
            }
            {
                viewActivityLog ?
                    <ViewActivityLog
                        dialogOpenClose={viewActivityLog}
                        handleClose={viewActivityClose}
                        handleSuccessClose={handleSuccessClose}
                        mdnNumber={mdnNumber}
                        accountNumber={accountNumber}
                        userName={customerInformation?.objCustomerInfo?.fullName}
                        loadActivityLogType={loadActivityLogType}
                    >
                    </ViewActivityLog> : null
            }
            {
                userSwapSim ? <SwapSim
                    dialogOpenClose={userSwapSim}
                    handleClose={() => setUserSwapSim(false)}
                    handleSuccessClose={handleSuccessClose}
                    loginUserName={loginUser.firstName}
                    mdnNumber={mdnNumber}
                    lineUserName={lineUserName}
                    oldICC={oldICC}
                    accountNumber={accountNumber}
                    userName={customerInformation?.objCustomerInfo?.fullName}
                    emailAddress={customerInformation?.objCustomerInfo?.email}
                /> : null
            }

            {addCash ?
                <AddCash dialogOpenClose={showAddCashDialog}
                    handleClose={closeAddCash}
                    handleSuccessClose={handleSuccessClose}
                    mdnNumber={mdnNumber}
                    accountNumber={accountNumber}
                    isPrepaid={isPrepaid}
                >
                </AddCash>
                : ''}

            {dataBoost ?
                <DataBoost dialogOpenClose={openDataBoost}
                    handleClose={closeDataBoost}
                    mdnNumber={mdnNumber}
                    accountNumber={accountNumber}
                    isPrepaid={isPrepaid}
                    handleSuccessClose={handleSuccessClose}
                >
                </DataBoost>
                : ''}
            {
                forwardNumberDialogState ? <LineForwardNumberDialog
                    dialogOpenClose={forwardNumberDialogState}
                    handleClose={() => setForwardNumberDialogState(false)}
                    handleSuccessClose={handleSuccessClose}
                    loginUserName={loginUser.firstName}
                    mdnNumber={mdnNumber}
                    wirelessId={wirelessId}
                    lineUserName={lineUserName}
                    accountNumber={accountNumber}
                    accountName={customerInformation?.objCustomerInfo?.fullName}
                    isPrepaid={isPrepaid}
                    lineDetails={lineDetails}
                /> : null
            }

            {
                showAddLineToExistingAccountDialog ?
                    <AddNewLine
                        dialogOpenClose={showAddLineToExistingAccountDialog}
                        handleClose={handleNewLineClose}
                        handleSuccessClose={handleActivateNewLineClose}
                        customerNumber={accountNumber}
                        customerName={customerInformation?.objCustomerInfo?.fullName}
                        accountNumber={accountNumber}
                        loginUserName={loginUser.firstName}
                        isPrepaid={isPrepaid}
                    ></AddNewLine>
                    : null
            }
            {showPortANumber ?
                <PortANumber
                    dialogOpenClose={showPortANumber}
                    handleSuccessClose={handleSuccessClose}
                    handleClose={() => { setShowPortANumber(false) }}
                    userDate={customerInformation}
                    //updatedBillingInfoDashboard={updatedBillingInfoDashboard}
                    isPrepaid={isPrepaid}
                /> : ''
            }
            {
                changeShippingAddress ?
                    <ChangeShippingAddress
                        dialogOpenClose={changeShippingAddress}
                        handleClose={() => { setChangeShippingAddress(false) }}
                        handleSuccessClose={handleChangeAddressSuccessClose}
                        addressType={"updateBillingAddress"}
                        accountNumber={accountNumber}
                        objAddress={objAddress}
                    ></ChangeShippingAddress>
                    : null
            }

            {
                reconnectPhoneDialogFlag ? <ReconnectPhoneNumber
                    dialogOpenClose={reconnectPhoneDialogFlag}
                    handleClose={() => setReconnectPhoneDialogFlag(false)}
                    handleSuccessClose={handleSuccessClose}
                    loginUserName={loginUser.firstName}
                    mdnNumber={mdnNumber}
                    lineUserName={lineUserName}
                    oldICC={oldICC}
                    accountNumber={accountNumber}
                    userName={customerInformation?.objCustomerInfo?.fullName}
                    emailAddress={customerInformation?.objCustomerInfo?.email}
                /> : null
            }
        </>
    )
}
export default withSnackbar(LineManagement);



